export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10658.e0e757ff.jpg";